<template>
  <expansion-panel
    key="expansion-panel-complements"
    :title="$t('offer-manager.create.step-complements.title')"
    :readonly="panelReadonly"
    :hideDivider="panelHideDivider">
    <template v-slot:panel-content>
      <packs :disabled="disabled" :is-editing="isEditing" />
      <complements :disabled="disabled" />
    </template>
  </expansion-panel>
</template>

<script lang="ts">
import {defineComponent, inject, ref} from '@vue/composition-api'

import ExpansionPanel from '@/components/general/ExpansionPanel.vue'
import Complements from '@/components/offer-manager/sections/Complements.vue'
import Packs from '@/components/offer-manager/sections/Packs.vue'

export default defineComponent({
  name: 'Accessories',
  components: {Complements, Packs, ExpansionPanel},
  props: {
    panelReadonly: {
      type: Boolean,
      default: false,
    },
    panelHideDivider: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const isEditing = inject('isEditing', ref(false))

    return {isEditing}
  },
})
</script>

<style lang="scss">
.m-interactive-list--btn-remove {
  margin-left: 12px;
}
</style>
